export default "__VITE_ASSET__$fqkJJL6__"